import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  descriptionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    width: "470px",
    borderRadius: "4px",
  },
  description: {
    fontSize: "14px",
    fontFamily: "Roboto",
    lineHeight: "100%",
    textAlign: "left",
    margin: "0px",
  },
}));
